import React from "react";
import { INTENTS, intentCopy } from "../../import/intent";

const IntentChooser = ({ suggestion, intent, onChange, includeRouteList, onIncludeRouteList, routeList = [], isLoggedIn = false }) => {
  if (!suggestion || !suggestion.options.length) return null;
  const { signals } = suggestion;
  // "Only build services" needs registered students; without an account there is nothing to place them on.
  const options = suggestion.options.filter((option) => option !== INTENTS.ROUTES_ONLY || isLoggedIn || signals.passengerCount === 0);
  if (!options.length) return null;
  const showRouteListToggle =
    (intent === INTENTS.PASSENGERS_ROUTES || intent === INTENTS.ROUTES_ONLY) &&
    signals.routeListWithoutPassengers > 0 &&
    routeList.length > 0;
  const question = signals.passengerCount > 0 ? "What should we do with this file?" : "This file lists services. What should we do?";

  return (
    <section className="start-ask" aria-labelledby="start-intent-title">
      <h3 id="start-intent-title">{question}</h3>
      <div className="start-ask__options" role="radiogroup" aria-label="What to do with this file">
        {options.map((option) => {
          const copy = intentCopy(option, signals);
          const selected = intent === option;
          const suggested = suggestion.suggested === option;
          return (
            <button
              key={option}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`start-ask__option${selected ? " is-selected" : ""}`}
              onClick={() => onChange(option)}
            >
              <span className="start-ask__radio" aria-hidden="true" />
              <span className="start-ask__body">
                <strong>
                  {copy.title}
                  {suggested && <em className="start-ask__tag">Suggested</em>}
                </strong>
                <span>{copy.detail}</span>
              </span>
            </button>
          );
        })}
      </div>
      {suggestion.reason && <p className="start-muted start-ask__reason">{suggestion.reason}</p>}
      {showRouteListToggle && (
        <label className="start-check start-ask__toggle">
          <input type="checkbox" checked={includeRouteList} onChange={(event) => onIncludeRouteList(event.target.checked)} />
          <span>
            Also create the {signals.routeListWithoutPassengers} service{signals.routeListWithoutPassengers === 1 ? "" : "s"} listed in the
            file that nobody rides yet
          </span>
        </label>
      )}
    </section>
  );
};

export default IntentChooser;
